import { Component, Input, OnInit } from '@angular/core';
import { HeaderContent } from '../../model/headerContent';
import { Content } from '../../model/content';

@Component({
    selector: 'pme-window-shop-manager-header',
    templateUrl: './window-shop-manager-header.component.html',
    styleUrls: ['./window-shop-manager-header.component.scss'],
    standalone: false
})
export class WindowShopManagerHeaderComponent implements OnInit {

  @Input() headerContent: HeaderContent;

  constructor() {
  }

  ngOnInit(): void {
  }

}
